import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import media from '~/client/shared/media';

const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: block;
  border-top-left-radius: ${rem(4)};
  background: none;
  margin-top: ${rem(-48)};
  margin-left: 0;
  padding-top: 0;
  ${media.phoneMedium} {
    display: flex;
    margin-top: ${rem(-80)};
    margin-left: ${rem(64)};
    padding-top: ${rem(52)};
    background: ${({ theme }) => theme.color.goku[100]};
  }
  ${media.desktopSmall} {
    margin-left: ${rem(100)};
  }
`;

export default ContentWrapper;
